/* ==============================================================
   AMIGO PROVISIONS — Mobile menu drawer toggle
   --------------------------------------------------------------
   Pairs with .amigo-drawer markup in sections/amigo-header.liquid.
   Opens when any element with aria-controls="amigo-menu-drawer"
   is clicked; closes via the close button, backdrop click, or ESC.
   ============================================================== */
(() => {
  const drawer = document.getElementById('amigo-menu-drawer');
  if (!drawer) return;

  const setOpen = (open) => {
    drawer.setAttribute('data-open', String(open));
    document.body.style.overflow = open ? 'hidden' : '';
    const opener = document.querySelector('[aria-controls="amigo-menu-drawer"]');
    if (opener) opener.setAttribute('aria-expanded', String(open));
    if (open) {
      const firstLink = drawer.querySelector('.amigo-drawer__link, .amigo-drawer__close');
      if (firstLink) firstLink.focus({ preventScroll: true });
    }
  };

  document.querySelectorAll('[aria-controls="amigo-menu-drawer"]').forEach((btn) => {
    btn.setAttribute('aria-expanded', 'false');
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      setOpen(drawer.getAttribute('data-open') !== 'true');
    });
  });

  drawer.querySelectorAll('[data-amigo-drawer-close]').forEach((el) => {
    el.addEventListener('click', () => setOpen(false));
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.getAttribute('data-open') === 'true') {
      setOpen(false);
    }
  });
})();

/* ==============================================================
   AMIGO PROVISIONS — Desktop nav dropdowns
   --------------------------------------------------------------
   Parent nav items with children ([data-nav-dropdown]) reveal a
   sublink panel. CSS handles mouse hover on its own; this drives
   click / keyboard activation by toggling data-open, plus Escape
   and outside-click dismissal, keeping aria-expanded in sync.
   ============================================================== */
(() => {
  const items = document.querySelectorAll('[data-nav-dropdown]');
  if (!items.length) return;

  const setOpen = (item, open) => {
    item.setAttribute('data-open', String(open));
    const toggle = item.querySelector('.nav__toggle');
    if (toggle) toggle.setAttribute('aria-expanded', String(open));
  };

  const closeAll = (except) => {
    items.forEach((item) => {
      if (item !== except) setOpen(item, false);
    });
  };

  items.forEach((item) => {
    const toggle = item.querySelector('.nav__toggle');
    if (!toggle) return;

    toggle.addEventListener('click', (e) => {
      e.preventDefault();
      const willOpen = item.getAttribute('data-open') !== 'true';
      closeAll(item);
      setOpen(item, willOpen);
    });

    item.addEventListener('focusout', (e) => {
      if (!item.contains(e.relatedTarget)) setOpen(item, false);
    });
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAll();
  });

  document.addEventListener('click', (e) => {
    if (![...items].some((item) => item.contains(e.target))) closeAll();
  });
})();
